import * as React from "react";
import ChevronIcon from "material-ui/svg-icons/navigation/chevron-left";
import IconButton from "material-ui/IconButton";
import Label from "components/form/label";
import theme from "styles/theme";
import _ from "lodash";

const muiStyles = {
    popover: {
        maxWidth: "400px",
        padding: "12px",
        overflowY: "auto",
    },
    select: {
        border: `1px solid ${theme.palette.borderColor}`,
        width: "220px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        padding: "0 10px",
        position: "relative" as "relative",
        height: "40px",
        cursor: "pointer",
    },
    selectedLabel: {
        overflow: "hidden",
        maxWidth: "180px",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap" as "nowrap",
    },
    label: {
        marginTop: "16px",
    },
    chevronIcon: {
        transform: "rotate(-90deg)",
    },
    iconButton: {
        position: "absolute" as "absolute",
        right: "0px",
    },
    error: {
        border: `1px solid ${theme.palette.error}`,
    },
    errorText: {
        color: theme.palette.error,
        fontSize: "12px",
        paddingTop: "10px",
        lineHeight: "12px",
    },
};

interface IProps {
    children: React.ReactNode;
    label: string;
    errorText?: string;
    dataTest?: string;
    placeholder: string;
    onClick?: () => void;
    styles?: { [key: string]: React.CSSProperties };
}

const SelectWrapper = React.memo(function SelectWrapperFC(props: IProps) {
    const { children, label, onClick, placeholder, styles = {}, errorText, dataTest } = props;
    const selectStyles = styles?.select ?? {};

    return (
        <React.Fragment>
            <Label dataTest={dataTest} style={{ ...muiStyles.label, ...styles.labelStyle }}>
                {label}
            </Label>
            <div
                className="selectDropdown"
                style={{ ...muiStyles.select, ...selectStyles, ...(errorText && muiStyles.error) }}
                onClick={onClick}
            >
                <span style={muiStyles.selectedLabel}>{placeholder}</span>
                <IconButton iconStyle={muiStyles.chevronIcon} style={muiStyles.iconButton}>
                    <ChevronIcon />
                </IconButton>
            </div>
            {children}
            {!_.isEmpty(errorText) && <div style={{ ...muiStyles.errorText, ...styles.errorText }}>{errorText}</div>}
        </React.Fragment>
    );
});

export { SelectWrapper };
